import gql from 'graphql-tag';
export default gql`
  query($activationCode: String!) {
    valid(activationCode: $activationCode)
  }
`;
